import IconButton from "components/IconButton"
import PercentualComAlerta from "components/PercentualComAlerta"
import { useState } from "react"
import { formatNumber } from "services/Utils"

export default function Item(props) {
  const [aberto, setAberto] = useState(false)

  const { id, codigo, descricao, filhos, itens } = props
  const nivel = props.nivel || 0

  const tipo = (!!itens || !!filhos) ? 'grupo' : 'item'

  if (tipo === 'grupo') {
    const { totais } = props

    const valorPrevisto = totais.find(t => t.propriedade == 'valorPrevisto').total
    const valorPrevistoFmt = totais.find(t => t.propriedade == 'valorPrevisto').totalFmt
    const valorDistribuido = totais.find(t => t.propriedade == 'valorDistribuido').total
    const valorDistribuidoFmt = totais.find(t => t.propriedade == 'valorDistribuido').totalFmt
    const saldoValorDistribuidoFmt = totais.find(t => t.propriedade == 'saldoValorDistribuido').totalFmt
    const percentualDistribuido = valorDistribuido / valorPrevisto * 100
    const valorExecutado = totais.find(t => t.propriedade == 'valorExecutado').total
    const valorExecutadoFmt = totais.find(t => t.propriedade == 'valorExecutado').totalFmt
    const saldoValorExecutadoFmt = totais.find(t => t.propriedade == 'saldoValorExecutado').totalFmt
    const percentualExecutado = valorExecutado / valorPrevisto * 100

    return (
      <>
        <tr className="grupo" key={id}>
          <td><span style={{ paddingLeft: nivel * 20 }}>{codigo}</span></td>
          <td className="text-wrap">{descricao}</td>
          <td className="text-right">{valorPrevistoFmt}</td>
          <td className="text-right">{valorDistribuidoFmt}</td>
          <td className="text-right">{saldoValorDistribuidoFmt}</td>
          <td className="text-right"><PercentualComAlerta valor={percentualDistribuido} /></td>
          <td className="text-right">{valorExecutadoFmt}</td>
          <td className="text-right">{saldoValorExecutadoFmt}</td>
          <td className="text-right"><PercentualComAlerta valor={percentualExecutado} /></td>
          <td>
            <span
              style={{ cursor: 'pointer', width: 24, height: 24, display: "inline-block", display: "flex", justifyContent: "center", alignItems: 'center' }}
              onClick={() => setAberto(!aberto)}
            >
              {aberto ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
            </span>
          </td>
        </tr>
        {(aberto) && (
          <>
            {itens.map(el => <Item key={el.id} {...el} />)}
            {filhos.map(el => <Item key={el.id} {...el} nivel={nivel + 1} />)}
          </>
        )}
      </>
    )
  } else if (tipo == 'item') {
    const {
      valorPrevistoFmt, valorDistribuidoFmt, saldoValorDistribuidoFmt, percentualValorDistribuido, valorExecutadoFmt, saldoValorExecutadoFmt,
      percentualValorExecutado
    } = props

    return (
      <tr key={id}>
        <td>{codigo}</td>
        <td className="text-wrap">
          {descricao}
        </td>
        <td className="text-right">{valorPrevistoFmt}</td>
        <td className="text-right">{valorDistribuidoFmt}</td>
        <td className="text-right">{saldoValorDistribuidoFmt}</td>
        <td className="text-right"><PercentualComAlerta valor={percentualValorDistribuido} /></td>
        <td className="text-right">{valorExecutadoFmt}</td>
        <td className="text-right">{saldoValorExecutadoFmt}</td>
        <td className="text-right"><PercentualComAlerta valor={percentualValorExecutado} /></td>
      </tr>
    )
  }
}